import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {
    getAmplitudePropertySelectItemEventProperties,
    IGetAmplitudePropertySelectItemEventPropertiesParams
} from "./get_amplitude_property_select_item_event_properties";

export const trackAmplitudePropertySelectItem = (params: IGetAmplitudePropertySelectItemEventPropertiesParams) => {
    trackAmplitudeEvent("select_item", getAmplitudePropertySelectItemEventProperties(params));
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {
    getAmplitudePropertySelectItemEventProperties,
    IGetAmplitudePropertySelectItemEventPropertiesParams
} from "./get_amplitude_property_select_item_event_properties";

export const trackAmplitudePropertySelectItem = (params: IGetAmplitudePropertySelectItemEventPropertiesParams) => {
    trackAmplitudeEvent("select_item", getAmplitudePropertySelectItemEventProperties(params));
};
